import { render, staticRenderFns } from "./CaseNotesList.vue?vue&type=template&id=bc86ebc8&scoped=true&"
import script from "./CaseNotesList.vue?vue&type=script&lang=js&"
export * from "./CaseNotesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc86ebc8",
  null
  
)

export default component.exports